import { z } from "zod";
export const dmaChemicalElementCountDtoSchema = z.object({
    symbol: z.string(),
    count: z.number(),
});
